module.exports = __webpack_public_path__ + "img/warm.2dc8f31d.png";